import { useEffect, useState } from "react";
import { mapsApiEndpoint, mapsApiKey } from "../constants/maps.constants";

export const useMapsHook = () => {
    // Constants
    const geocodingEndpoint = `${mapsApiEndpoint}/geocode/json`;

    // Hook state
    const [geolocations, setGeolocations] = useState<any[]>([]);
    const [error, setError] = useState<string>('');

    // Get locations
    const getGeocodingLocations = async (text: string) => {
        const locations: any[] = [];

        try {
            // Call the Geocoding API
            const geocodingRequest = fetch(`${geocodingEndpoint}?address=${text.replace(/\s/g, '+')}&key=${mapsApiKey}`, {
                method: 'get'
            });
            const geocodingResponse = await geocodingRequest;

            // Response handling
            const responseJson = (await geocodingResponse.json());
            if (responseJson.status !== 'OK') {
                setError('Ocurrió un error desconocido al analizar la solicitud, por favor inténtelo más tarde');
                return;
            }

            const matches = responseJson.results;
            if (!matches.length) {
                // Error, nothing found
                setError('No se encontró la localización, por favor introduce una dirección correct');
                return;
            }
            
            // No error, prioritize precise location match "ROOFTOP"
            setError('');

            // Matches on precision order
            const rooftopMatches = matches.filter(({ geometry }: any) => geometry.location_type === "ROOFTOP");
            const interpolatedMatches = matches.filter(({ geometry }: any) => geometry.location_type === "RANGE_INTERPOLATED");
            const geometricCenterMatches = matches.filter(({ geometry }: any) => geometry.location_type === "GEOMETRIC_CENTER");
            const approximateMatches = matches.filter(({ geometry }: any) => geometry.location_type === "APPROXIMATE");

            locations.push(...rooftopMatches);
            locations.push(...interpolatedMatches);
            locations.push(...geometricCenterMatches);
            locations.push(...approximateMatches);
        } catch (err) {
            setError('Ocurrió un error desconocido al analizar la solicitud, por favor inténtelo más tarde');
            console.error(err);
        }

        setGeolocations(locations);
    }

    return {
        geolocations,
        error,
        getGeocodingLocations,
        setGeolocations
    };
}